import React from 'react';
import {AnomalyDetection, MultiRegressionGPU} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';
import Box from 'grommet/components/Box';
import Layer from 'grommet/components/Layer';
import Button from 'grommet/components/Button';
import TextInput from 'grommet/components/TextInput';
import Tabletop from "../samples/data/Tabletop.js"
import Label from 'grommet/components/Label';
import Spinning from 'grommet/components/icons/Spinning';

const urlViews = "https://docs.google.com/spreadsheets/d/1z0D11-3XAz7UDjWXOmxFKcpMjJtcl0dJP2_YVWXVuQU/edit?usp=sharing";

class Anomaly extends React.Component {
    constructor() {
        super();
        this.state = { 
            time: null,
            showcomponent: false,
            finalResult: null,
            steps: 4,
            epsilon: 0.01,
            predictData: null,
            model: [],
            email: null,
            alertNull: false,
            spinningFlag: true,
            text: "To retrieve your view, please enter your email/username."
        }
    }
    componentDidMount() {
        const searchParam = window.location.search
        this.getView(urlViews, searchParam)
    }
    _onChange(event) {
        this.setState({email: event.target.value})
    }
    _onSubmit() {
        const {email} = this.state

        //this.getView(urlViews, email)
    }
    getView(url, searchParam) {
        //const id = window.location.search
        this.setState({spinningFlag: true}) 
        const that = this;
        Tabletop.init({ key: url, //publicSpreadsheetUrl,
            callback: showInfo,
            simpleSheet: true,
            parseNumbers: true
        })
        function showInfo(data, tabletop) {
            console.log('Successfully processed!')
            let foundit = 0;
            data.forEach((ele, index)=>{
                if (`?id=${ele.id}` === searchParam) {
                    foundit = 1
                    that.queryGoogle(ele.url, ele.model)
                }
            })
            if (!foundit) that.setState({text: "No Email Found. Re-enter your email and try again", spinningFlag: false})
        }
    }
    queryGoogle(url, model) {
        const modelParsed = (model) ?  JSON.parse(model) : []
        const that = this;
        Tabletop.init({ key: url, //publicSpreadsheetUrl,
            callback: showInfo,
            simpleSheet: true,
            parseNumbers: true
        })
        let Arrayarray = [];
        function showInfo(data, tabletop) {
            console.log('Successfully processed!')
            const rows = data.length;
            const keys = Object.keys(data[0])
            const lengthKeys = keys.length;
             
            for (let i = 0; i < lengthKeys; i++) {
                let tempArray = []
                data.forEach((ele, index)=>{
                    tempArray.push(ele[keys[i]])
                })
                Arrayarray.push(tempArray)
            }
            that.setState({showcomponent: true, predictData: Arrayarray, model: modelParsed, alertNull: false, spinningFlag: false})
        }
        this.setState({showcomponent: false})
    }



    parseObject(dataObject) {
        let dataObjectParsed = [];
        if (dataObject) {
            dataObject.forEach((input1, index)=> {
                if (input1) {
                    input1.forEach((input2, index2)=>{
                        let object;
                        if (index === 0) {
                            object = {date: input2}
                            dataObjectParsed.push(object);
                        } else if (index === 1) {
                            Object.assign(dataObjectParsed[index2], {value: input2})
                        }
                    })
                    
                }
            })
        }
        return dataObjectParsed
    } 
   
    
    render() {        
        const {showcomponent, predictData, model, alertNull, spinningFlag, text} = this.state
        let alert, spinningComponent, component;

        if (spinningFlag) {
            spinningComponent = <div style={{position: "fixed", backgroundColor: "white", top: "0px", 
            bottom: "0px", right: "0px", left: "0px", opacity: "0.5", paddingTop: "30%",
            zIndex: "500", textAlign: "center"}}>
                <Label>Loading...</Label>
                <Spinning size={"huge"}/>
            </div>
        } else {
            spinningComponent = <div></div>
        }


        if (alertNull) {
        alert = <Layer align="center" >
        {spinningComponent}
        <div style={{padding: "25px"}}>
            <Box direction='row'
                                    justify='start'
                                    align='left'
                                    wrap={true}
                                    reverse={false}
                                    margin='none'>
                <Label>{text}</Label>
                <br/>
                <Box direction='row'
                    align='center'
                    wrap={true}
                    pad='small'
                    margin='none'>
                        <input 
                            style={{padding: "0px 24px", width: "400px"}}
                         placeholder={"Email"}
                         onChange={this._onChange.bind(this)} 
                            />  
                    </Box>
                    <Box direction='row'
                                        align='center'
                                        wrap={true}
                                        pad='medium'
                                        margin='none'><Button label='Submit'
                                        type='submit'
                                        primary={true}
                                        onClick={this._onSubmit.bind(this)} /></Box>
                
        </Box>
        </div>
        
        
        </Layer>
        } else {
        alert = <div></div>
        }
        const finDataObjectPredict = this.parseObject(predictData)
        console.log(predictData)
        if (model.mla === "anomaly") {
            component = (<div style={{width: "100%"}}>
            <AnomalyDetection 
                model={model}
                predictdata={finDataObjectPredict} 
                 />
        </div>)
        } else if (model.mla === "mlrgd") {
            component = (<div style={{width: "100%"}}>
                <MultiRegressionGPU 
                    model={model}
                    predictdata={predictData} 
                    />
            </div>)
        }
       
        

        return (
            <div>
                {spinningComponent}
                {alert}
                <h2><strong>{model.mla === "anomaly" ? "Anomaly Analysis" : "Multi Linear Regression" }</strong></h2>                
                 {(showcomponent) && component}
            </div>
        );
    }
}


export default Anomaly;



// WEBPACK FOOTER //
// ./src/users/Custom.js